/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StoragePolicyFilter { 
    /**
     * The namespace of the registered business object definition. It is required when businessObjectDefinitionName is present                
     */
    namespace?: string;
    /**
     * The name of the registered business object definition. It is required when namespace is present
     */
    businessObjectDefinitionName?: string;
    /**
     * The business object format usage. The usage does not need to exist in the system. It is required when                   businessObjectFormatFileType is present                
     */
    businessObjectFormatUsage?: string;
    /**
     * The business object format file type. The file type must be known by the system. It is required when businessObjectFormatUsage                   is present                
     */
    businessObjectFormatFileType?: string;
    /**
     * The name of the storage that this storage policy applies to. The storage with this name must already exist. Currently, only S3                   storage platform type is supported by the storage policies                
     */
    storageName: string;
    /**
     * If true, this storage policy will not transition latest valid business object data versions
     */
    doNotTransitionLatestValid?: boolean;
}
